<template>
    <header class="text-center mb-4">
        <h2 class="skin-page-heading">Partners Income</h2>
    </header>

    <div class="row">
        <div class="col-md-5 mx-auto text-center">
            <p>
                This is coming soon to help you manage retirement as a couple. This will be available for Guiide.auto customers to help manage their automated retirement plan.
            </p>
        </div>
    </div>
</template>
